'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Settings;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function Settings(_ref) {
  var size = _ref.size,
    strokeColor = _ref.strokeColor,
    strokeWidth = _ref.strokeWidth,
    fillColor = _ref.fillColor,
    svgClass = _ref.svgClass;
  var inlineStyling = {
    fill: fillColor,
    stroke: strokeColor,
    strokeWidth: strokeWidth
  };
  return _react2.default.createElement('svg', {
    className: svgClass,
    height: size,
    style: inlineStyling,
    viewBox: '0 0 24 24',
    width: size,
    xmlns: 'http://www.w3.org/2000/svg'
  }, _react2.default.createElement('path', {
    d: 'M17.7274653,12.776 L19.4154653,14.104 C19.5674653,14.224 19.6074653,14.44 19.5114653,14.616 L17.9114653,17.384 C17.8154653,17.56 17.5994653,17.624 17.4234653,17.56 L15.4314653,16.752 C15.0154653,17.072 14.5834653,17.336 14.0794653,17.544 L13.7834653,19.664 C13.7514653,19.856 13.5834653,20 13.3834653,20 L10.1834653,20 C9.98346528,20 9.81546528,19.856 9.78346528,19.664 L9.48746528,17.544 C8.98346528,17.344 8.55146528,17.072 8.13546528,16.752 L6.14346528,17.56 C5.96746528,17.624 5.75146528,17.56 5.65546528,17.384 L4.05546528,14.616 C3.95146528,14.44 3.99946528,14.224 4.15146528,14.104 L5.83946528,12.776 C5.80746528,12.52 5.78346528,12.264 5.78346528,12 C5.78346528,11.736 5.80746528,11.472 5.83946528,11.2 L4.15146528,9.896 C3.99946528,9.776 3.95146528,9.56 4.05546528,9.384 L5.65546528,6.616 C5.75146528,6.44 5.96746528,6.368 6.14346528,6.44 L8.13546528,7.24 C8.55146528,6.928 8.98346528,6.656 9.48746528,6.456 L9.78346528,4.336 C9.81546528,4.144 9.98346528,4 10.1834653,4 L13.3834653,4 C13.5834653,4 13.7514653,4.144 13.7834653,4.336 L14.0794653,6.456 C14.5834653,6.656 15.0154653,6.928 15.4314653,7.24 L17.4234653,6.44 C17.5994653,6.368 17.8154653,6.44 17.9114653,6.616 L19.5114653,9.384 C19.6074653,9.56 19.5674653,9.776 19.4154653,9.896 L17.7274653,11.2 C17.7594653,11.472 17.7834653,11.736 17.7834653,12 C17.7834653,12.264 17.7594653,12.52 17.7274653,12.776 Z M11.7834653,14.8 C13.3298626,14.8 14.5834653,13.5463973 14.5834653,12 C14.5834653,10.4536027 13.3298626,9.2 11.7834653,9.2 C10.237068,9.2 8.98346528,10.4536027 8.98346528,12 C8.98346528,13.5463973 10.237068,14.8 11.7834653,14.8 Z'
  }));
}
Settings.defaultProps = {
  strokeColor: 'blue',
  strokeWidth: 0,
  fillColor: '#bada55',
  size: 32,
  svgClass: 'sui-SVGicon'
};